import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Switch from 'react-switch'
import Markdown from 'react-remarkable'

const Description = ({ text }) => (
  text ? (
    <span className='grey-text word-break'>
      <Markdown source={text} />
    </span>
  ) : null
);

class CompletedChecklistForm extends React.Component {
  state = {
    tasks: this.props.completedChecklist.tasks,
    createdAt: this.props.completedChecklist.created_at ? moment(this.props.completedChecklist.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    timeStamp: this.props.completedChecklist.time_stamp ? moment(this.props.completedChecklist.time_stamp).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss')

  }

  saveCompletedChecklist = () => {
    var that = this
    var d = new Date()
    var hours = d.getHours()
    var mins = d.getMinutes()

    if(this.props.completedChecklist.id) {
      axios.put('/completed_checklists/' + this.props.completedChecklist.id,
        {
          completed_checklist: {
            tasks_attributes: that.state.tasks,
            time_stamp: moment(that.state.timeStamp)
          }
        }
      )
      .then(function (response) {
        toastr.info('Checklist updated')
        setTimeout(function() { Turbolinks.visit('/completed_checklists/' + that.props.completedChecklist.id) }.bind(this), 800)
      })
      .catch(function (error) {
        toastr.error('Checklist not updated')
        console.log(error)
      })
    }
    else {
      axios.post('/completed_checklists', {
        completed_checklist: {
          check_list_id: that.props.checklistId,
          location_id: that.props.locationId,
          tasks_attributes: that.state.tasks,
          time_stamp: moment(that.state.timeStamp)
        }
      })
      .then(function (response) {
        toastr.success('Checklist created')
        setTimeout(function() { Turbolinks.visit('/completed_checklists') }.bind(that), 800)
      })
      .catch(function (error) {
        toastr.error('Checklist not created')
        console.log(error)
      })
    }
  }

  renderNoTasksMessage = () => {
    return(
      <div>
      <br />
        <center>
          <p className='pink-text'>
            This checklist has no tasks or has no tasks that are to be completed today
          </p>
        </center>
      <br />
      </div>
    )
  }

  toggleTask = (e, task, index) => {
    var tasks = this.state.tasks
    task.completed = !task.completed

    if (task.completed) {
      task.user_id = this.props.currentUser.id
    }
    else {
      task.user_id = null
    }

    tasks[index] = task
    this.setState({ tasks: tasks })
  }

  setNotes = (e, task, index) => {
    var tasks = this.state.tasks
    task.notes = e.target.value
    tasks[index] = task
    this.setState({ tasks: tasks })
  }

  setTimeStamp = (e) => {
    this.setState({ timeStamp: moment(e.target.value).format('YYYY-MM-DD HH:mm:ss') })
  }

  renderTasks() {
    var that = this

    var taskFormElements = this.state.tasks.map((task, index) => {
      return(
        <div key={index}
             className='row'>
          <div className='col-xs-12'>
            <b>
              {task.name}
            </b>
          </div>
          <div className='col-xs-2 col-sm-1'>
            <br />
            <label id="checklist-toggle-label" htmlFor="material-switch" className="sr-only">
              Checklist Toggle
            </label>
            <Switch
              checked={task.completed}
              onChange={e => that.toggleTask(e, task, index)}
              aria-labelledby="checklist-toggle-label"
              onColor="#DADCE1"
              onHandleColor="#3A4590"
              handleDiameter={25}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
              activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
              height={20}
              width={48}
              className='react-switch'
              id='material-switch'
            />
          </div>
          <div className='col-xs-10 col-sm-11'>
            <br />
            <div className='form-group'>
              <input
                className='form-control'
                name='notes'
                type='text'
                placeholder='Notes...'
                value={task.notes || ''}
                onChange={(e) => that.setNotes(e, task, index)}/>
            </div>
          </div>
        </div>
      )
    })

    return(
      <div>{ taskFormElements }</div>
    )
  }

  renderSaveButton() {
    var that = this

    return(
      <button type='button'
              className='btn btn-pink full-width'
              onClick={ function(){ that.saveCompletedChecklist() }}>
        SAVE
      </button>
    )
  }

  render() {
    const { description } = this.props;

    if (this.props.completedChecklist.tasks &&
        this.props.completedChecklist.tasks.length) {
      return(
        <div>
          <Description text={description} />

          {this.renderTasks()}
          {this.props.currentUser.admin &&
            <div className='col-xs-12 col-md-6'>
              <hr />
              <label>
                Date* (Admin Only)
              </label>
              <br />
              <input className='form-control'
                     title='date'
                     type='datetime-local'
                     onChange={(e) => this.setTimeStamp(e)}
                     value={this.state.timeStamp} />
            </div>
          }
          {this.renderSaveButton()}
        </div>
      )
    } else {
      return(
        <div>
          <Description text={description} />
          {this.renderNoTasksMessage()}
        </div>
      )
    }
  }
}

Description.propTypes = {
  text: PropTypes.string
};

CompletedChecklistForm.propTypes = {
  completedChecklist: PropTypes.object,
  checklistId: PropTypes.number,
  currentUser: PropTypes.object
}

export default CompletedChecklistForm
